import { ScreenSizeWidth } from './enums';

export const isMobile = window.innerWidth < ScreenSizeWidth.small;
